import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=273aeff2&scoped=true"
import script from "./ChatContent.vue?vue&type=script&lang=js"
export * from "./ChatContent.vue?vue&type=script&lang=js"
import style0 from "./ChatContent.vue?vue&type=style&index=0&id=273aeff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273aeff2",
  null
  
)

export default component.exports